import { ThemedButton } from "Components/Themes/components/ThemedButton";
import React from "react";

export interface Props {
  onClick: () => void;
  buttonText: string;
}

export const AddBuildingButton = ({
  onClick,
  buttonText,
}: Props): React.ReactElement => {
  return (
    <ThemedButton
      onClick={onClick}
      variant="text"
      iconLeft="add"
      id="addBuildingButton"
      trackId={buttonText}
    >
      {buttonText}
    </ThemedButton>
  );
};
